module.exports = __webpack_public_path__ + "img/subject_03.jpg";